import { render, staticRenderFns } from "./DraftOrderRow.vue?vue&type=template&id=2f2647e0"
import script from "./DraftOrderRow.vue?vue&type=script&lang=js"
export * from "./DraftOrderRow.vue?vue&type=script&lang=js"
import style0 from "./DraftOrderRow.vue?vue&type=style&index=0&id=2f2647e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports